<template>
  <div class="button-area">
    <button
      v-for="(data, index) in actionButtonList"
      :key="`voucher_button__${data?.productid}__${index}`"
      type="button"
      :class="['btn', { selected: data?.productid === selectedProductId }]"
      @click="$emit('on-click-purchase', data)"
    >
      <span class="month">
        <span>{{ data?.use_day ?? '' }}</span>

        <span v-if="isDiscount(data)" class="discount"
          >{{ data?.discount_rate ?? '' }}%</span
        >
      </span>
      <span class="price">
        <span>&#65510;{{ setNumberComma(data?.amount ?? '') }}</span>

        <span v-if="isMonthAmount(data)" class="summary"
          >(월 &#65510;{{ setNumberComma(data?.month_amount ?? '') }})</span
        >
        <span v-if="isShowPromotionText(data)" class="summary"
          >Google Play 첫 결제 시, 첫 달 ￦100*</span
        >
      </span>
    </button>
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import { setNumberComma } from '@/common/util/set-number-comma'
  import utils from '@/common/util/utils'
  import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
  import { PAYMENT_GATE_TYPE_ONE_STORE } from '@/common/constant'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => {},
      required: true,
    },
    voucherItem: {
      type: Object,
      default: () => {},
    },
    selectedProductId: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-purchase'])

  const pgName = computed(() => utils.getPgName() ?? '')

  const actionButtonList = computed(
    () => props.voucherItem?.purchase_amount_info_list ?? [],
  )
  const isAndroidOS = computed(
    () => utils.cookies.getDevice() === DEVICE_TYPE_ANDROID,
  )

  const isShowPromotionText = (data) => {
    // 현재 서버 드리븐이 아니기 때문에 임시로 discount_rate 가 없을 경우 안드로이드에서 GooglePay 텍스트 표기
    if (pgName.value === PAYMENT_GATE_TYPE_ONE_STORE) {
      return false
    }
    return isAndroidOS.value && (data?.discount_rate ?? '') === ''
  }

  const isDiscount = (data) => {
    return (data?.discount_rate ?? '') !== ''
  }

  const isMonthAmount = (data) => {
    return (data?.month_amount ?? '') !== ''
  }
</script>
